import React, { useEffect, useState } from 'react';
import {
  useEnvironment,
  WidgetProps,
  useTranslation,
} from '@wix/yoshi-flow-editor';
import { st, classes } from './headerIcon.st.css';
import { ReactComponent as Icon } from './favoritesIcon.svg';
import { Tooltip } from 'wix-ui-tpa/Tooltip';
import { SignUpProvider } from '../../../common/context/SignUpContext/SignUpContext';

type HeaderIconProps = WidgetProps & {
  goToCollectionsPage: () => void;
  disableSelections?: boolean;
  isPreview: boolean;
  loggedIn: boolean;
  promptLogin: (params?: any) => void;
  showSignUpModal: { res: boolean; origin: string };
  onRefuseLoginRequest: () => void;
  albumId: string;
  collectionId?: string;
  stopShowingSignUpModal?: boolean;
  enableShowInfoModal?: () => void;
  controllerTime: number;
};

export default (props: HeaderIconProps) => {
  const [shown, setShown] = useState(!props.disableSelections);
  const { isEditor, isMobile } = useEnvironment();
  const {
    enableShowInfoModal,
    stopShowingSignUpModal,
    albumId,
    collectionId,
    showSignUpModal,
    promptLogin,
    onRefuseLoginRequest,
  } = props;

  const { dimensions } = props.host;
  const { width, height } = dimensions;
  const { t } = useTranslation();

  const onRefresh = ({ data }: { data: any }) => {
    if (data.type === 'refreshData') {
      const albumData = data?.data?.albumData;
      const allowSelections = albumData?.allowSelections;
      setShown(!!allowSelections);
    }
  };

  useEffect(() => {
    if (props.isPreview) {
      window.addEventListener('message', onRefresh);
      return () => {
        window.removeEventListener('message', onRefresh);
      };
    }
  }, []);

  return (
    <SignUpProvider
      showSignUpModal={showSignUpModal}
      openWixSignUp={promptLogin}
      onRefuseLoginRequest={onRefuseLoginRequest}
      collectionId={collectionId}
      albumId={albumId}
      instanceId={props.appParams?.instanceId}
      compId={props.host?.id}
      stopShowingSignUpModal={stopShowingSignUpModal}
      enableShowInfoModal={enableShowInfoModal}
      controllerTime={props.controllerTime}
    >
      <div
        onClick={() => {
          props.goToCollectionsPage && props.goToCollectionsPage();
        }}
        className={st(classes.container, { notLoggedIn: !props.loggedIn })}
      >
        {(shown || isEditor) && (
          <Tooltip
            content={t('FAVORITES_LISTS_HEADER_ICON_TOOLTIP')}
            disabled={isMobile}
            appendTo="window"
          >
            <Icon width={width || 24} className={classes.icon} />
          </Tooltip>
        )}
      </div>
    </SignUpProvider>
  );
};
